const ipv4Pattern = /^\d+(?:\.\d+)+$/;
// Emitted as a Set-Cookie attribute: "evil.test; Path=/" would append its own attributes.
const hostnamePattern = /^[a-z\d.-]+$/;

// "[::1]:3000" keeps its brackets; "www.solvari.nl:8443" loses its port.
function hostnameOf(host: string): string {
  if (host.startsWith("[")) {
    const closing = host.indexOf("]");
    // Unterminated literal: slicing would fabricate a hostname → keep it verbatim, callers reject it.
    return closing === -1 ? host : host.slice(0, closing + 1);
  }
  return host.split(":")[0] ?? host;
}

// IP literal or single-label host (localhost) → null; else last two labels.
// Last-two-labels — breaks for PSL suffixes like `co.uk`.
function registrableDomain(host: string): string | null {
  const hostname = hostnameOf(host).toLowerCase();
  if (!hostnamePattern.test(hostname) || ipv4Pattern.test(hostname)) {
    return null;
  }

  const labels = hostname.split(".");
  if (labels.length < 2) {
    return null;
  }

  return labels.slice(-2).join(".");
}

// Localhost, IP literal, or anything not a plain hostname → not a public host.
function isNonPublicHost(host: string): boolean {
  const hostname = hostnameOf(host).toLowerCase();
  return (
    hostname === "localhost" ||
    !hostnamePattern.test(hostname) ||
    ipv4Pattern.test(hostname)
  );
}

// `Solvari-Host` (edge) outranks `Host` (internal hop); non-public host → null, no public origin.
function resolvePublicHost({
  host,
  solvariHost,
}: {
  host: string | undefined;
  solvariHost: string | undefined;
}): string | null {
  const resolved = solvariHost || host;
  return !resolved || isNonPublicHost(resolved) ? null : resolved;
}

export { hostnameOf, isNonPublicHost, registrableDomain, resolvePublicHost };
